/**
 * <footer-newsletter> — validates the footer email input and redirects the
 * visitor to the full newsletter signup form page with the email pre-filled
 * as a `?email=` query param. The signup form reads that param on load.
 *
 * Markup contract:
 *   form[data-footer-newsletter]      — the form; carries data-form-url
 *   input[type="email"][name="email"] — the email field
 *   .newsletter-form__message         — error container
 *   .newsletter-form__message-error   — error text target inside the container
 */
if (!customElements.get('footer-newsletter')) {
  class FooterNewsletter extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form[data-footer-newsletter]');
      if (!this.form) return;

      this.input = this.form.querySelector('input[type="email"]');
      this.message = this.form.querySelector('.newsletter-form__message');
      this.messageText = this.message
        ? this.message.querySelector('.newsletter-form__message-error')
        : null;
      this.strings = window.newsletterFormStrings || {};
      this.emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    setError(text) {
      if (!this.message || !this.messageText) return;
      this.messageText.textContent = text || '';
      this.message.hidden = !text;
      this.message.style.display = text ? 'flex' : 'none';
    }

    onSubmit(event) {
      event.preventDefault();

      const email = ((this.input && this.input.value) || '').trim();

      if (!email) {
        this.setError(this.strings.emailRequired || 'Please enter your email address.');
        return;
      }
      if (!this.emailPattern.test(email)) {
        this.setError(this.strings.error || 'Please enter a valid email address.');
        return;
      }

      const formUrl = this.form.dataset.formUrl;
      if (!formUrl) return;

      const url = new URL(formUrl, window.location.origin);
      url.searchParams.set('email', email);
      window.location.href = url.toString();
    }
  }

  customElements.define('footer-newsletter', FooterNewsletter);
}
